import type { StoreTagDTO } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchStoreTags = async () => {
  const response = await gozokiApiWithAuth.get<{ tags: StoreTagDTO[] }>('/store-tags')
  return response.data.tags
}
